import script from "./esManageAdmin.vue?vue&type=script&setup=true&lang=ts"
export * from "./esManageAdmin.vue?vue&type=script&setup=true&lang=ts"

import "./esManageAdmin.vue?vue&type=style&index=0&id=1a1a513a&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a1a513a"]])

export default __exports__